import { call, put, takeLatest } from "redux-saga/effects";
import { OP } from "../../constant";
import {
  dofetchAllApi,
  doActivateApi,
  doApiDetails,
  doApproveApi,
  doDeactivateApi,
  doFetchAllApi,
  doRejectApi,
  doViewAPi,
  doGetPartnerProperties,
  doCreatePartnerProperty,
  doUpdatePartnerProperty,
  doUpdateFspCode,
  doUpdateOutboundCredentials,
  doDownloadKey,
} from "../../service/api";
import errorMessage from "../../utils/error.json";

/* ------------------------- API SAGA --------------------- */
// fetch api list
function* fetchApiTask(action) {
  try {
    yield put({ type: OP.API_LIST_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      dofetchAllApi,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.API_LIST_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.API_LIST_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.API_LIST_FAILURE,
      payload: errMsg,
    });
  }
}

// add api
function* apiDetailsTask(action) {
  try {
    yield put({ type: OP.API_DETAILS_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doApiDetails,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.API_DETAILS_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.API_DETAILS_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.API_DETAILS_FAILURE,
      payload: errMsg,
    });
  }
}

// view api
function* viewApiTask(action) {
  try {
    yield put({ type: OP.VIEW_API_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doViewAPi,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.VIEW_API_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.VIEW_API_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.VIEW_API_FAILURE,
      payload: errMsg,
    });
  }
}

// activate api
function* activateApiTask(action) {
  try {
    yield put({ type: OP.ACTIVATE_API_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doActivateApi,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.ACTIVATE_API_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.ACTIVATE_API_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.ACTIVATE_API_FAILURE,
      payload: errMsg,
    });
  }
}

// deactivate api
function* deactivateApiTask(action) {
  try {
    yield put({ type: OP.DEACTIVATE_API_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doDeactivateApi,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.DEACTIVATE_API_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.DEACTIVATE_API_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.DEACTIVATE_API_FAILURE,
      payload: errMsg,
    });
  }
}

// approve Api
function* approveApiTask(action) {
  try {
    yield put({ type: OP.APPROVE_API_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doApproveApi,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.APPROVE_API_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.APPROVE_API_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.APPROVE_API_FAILURE,
      payload: errMsg,
    });
  }
}

// reject Api
function* rejectApiTask(action) {
  try {
    yield put({ type: OP.REJECT_API_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doRejectApi,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.REJECT_API_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.REJECT_API_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.REJECT_API_FAILURE,
      payload: errMsg,
    });
  }
}

// get partner properties
function* getPartnerPropertiesTask(action) {
  try {
    yield put({ type: OP.GET_PARTNER_PROPERTIES_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doGetPartnerProperties,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.GET_PARTNER_PROPERTIES_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.GET_PARTNER_PROPERTIES_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.GET_PARTNER_PROPERTIES_FAILURE,
      payload: errMsg,
    });
  }
}

// create Partner property
function* createPartnerPropertyTask(action) {
  try {
    yield put({ type: OP.CREATE_PARTNER_PROPERTY_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doCreatePartnerProperty,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.CREATE_PARTNER_PROPERTY_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.CREATE_PARTNER_PROPERTY_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.CREATE_PARTNER_PROPERTY_FAILURE,
      payload: errMsg,
    });
  }
}

// update Partner property
function* updatePartnerPropertyTask(action) {
  try {
    yield put({ type: OP.UPDATE_PARTNER_PROPERTY_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doUpdatePartnerProperty,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.UPDATE_PARTNER_PROPERTY_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.UPDATE_PARTNER_PROPERTY_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.UPDATE_PARTNER_PROPERTY_FAILURE,
      payload: errMsg,
    });
  }
}

// update fsp code
function* updateFspCodeTask(action) {
  try {
    yield put({ type: OP.UPDATE_FSP_CODE_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doUpdateFspCode,
      payload.token,
      payload.data,
    );

    if (res.status === 200) {
      yield put({
        type: OP.UPDATE_FSP_CODE_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.UPDATE_FSP_CODE_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.UPDATE_FSP_CODE_FAILURE,
      payload: errMsg,
    });
  }
}

// update outbound credentials
function* updateOutboundCredentialsTask(action) {
  try {
    yield put({ type: OP.UPDATE_OUTBOUND_CREDENTIALS_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doUpdateOutboundCredentials,
      payload.token,
      payload.data,
    );

    if (res.status === 200) {
      yield put({
        type: OP.UPDATE_OUTBOUND_CREDENTIALS_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.UPDATE_OUTBOUND_CREDENTIALS_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.UPDATE_OUTBOUND_CREDENTIALS_FAILURE,
      payload: errMsg,
    });
  }
}

// download key
function* downloadKeyTask(action) {
  try {
    yield put({ type: OP.DOWNLOAD_KEY_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doDownloadKey,
      payload.token,
      payload.data,
    );

    if (res.status === 200) {
      yield put({
        type: OP.DOWNLOAD_KEY_SUCCESS,
        payload: decoded_data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.DOWNLOAD_KEY_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.DOWNLOAD_KEY_FAILURE,
      payload: errMsg,
    });
  }
}

function* apiSaga() {
  yield takeLatest(OP.API_LIST_REQUEST, fetchApiTask);
  yield takeLatest(OP.API_DETAILS_REQUEST, apiDetailsTask);
  yield takeLatest(OP.VIEW_API_REQUEST, viewApiTask);
  yield takeLatest(OP.ACTIVATE_API_REQUEST, activateApiTask);
  yield takeLatest(OP.DEACTIVATE_API_REQUEST, deactivateApiTask);
  yield takeLatest(OP.APPROVE_API_REQUEST, approveApiTask);
  yield takeLatest(OP.REJECT_API_REQUEST, rejectApiTask);
  yield takeLatest(OP.GET_PARTNER_PROPERTIES_REQUEST, getPartnerPropertiesTask);
  yield takeLatest(
    OP.CREATE_PARTNER_PROPERTY_REQUEST,
    createPartnerPropertyTask,
  );
  yield takeLatest(
    OP.UPDATE_PARTNER_PROPERTY_REQUEST,
    updatePartnerPropertyTask,
  );
  yield takeLatest(OP.UPDATE_FSP_CODE_REQUEST, updateFspCodeTask);
  yield takeLatest(
    OP.UPDATE_OUTBOUND_CREDENTIALS_REQUEST,
    updateOutboundCredentialsTask,
  );
  yield takeLatest(OP.DOWNLOAD_KEY_REQUEST, downloadKeyTask);
}

export default apiSaga;
